// Material Dashboard 2 React layouts
import Dashboard from "layouts/user/dashboard";
import SignIn from "layouts/authentication/sign-in";

// @mui icons
import Icon from "@mui/material/Icon";
import ProtectedRoute from "components/ProtectedRoute";
import SignOut from "layouts/authentication/logout";
import SignInProtectionRoute from "components/SignInProtectedRoute";
import MyScorecard from "layouts/user/KPIs/myScorecard";
import Assess from "layouts/user/KPIs/Assess";
import TeamView from "layouts/user/KPIs/myTeam";
import ChatPage from "layouts/user/KPIs/Chat";
import Overview from "layouts/user/profile";
import CompetencyToEmpTab from "layouts/user/Competencies/assess/index";
import MyCompetencies from "layouts/user/Competencies/myCompetencies";
import TrainingsTab from "layouts/user/Competencies/myTeam";
import AnalysisContainerPage from "layouts/user/WLA/myTeam";
import ScenarioPage from "layouts/user/WLA/Scenarios/scenarioPage";
import HoursCalculator from "layouts/user/WLA/ManpowerPlanning/HoursCalculator";
import ScenariosListPage from "layouts/user/WLA/Scenarios";
import ScenarioPageContainer from "layouts/user/WLA/Scenarios/ScenarioPageContainer";
import JobDetails from "layouts/admin/Organization/components/JobView/components/JobDetails";
import TalentAcquisitionPage from "layouts/admin/talentAcquisition";
import RequisitionDetails from "layouts/admin/talentAcquisition/RequisitionDetails";
import ExternalForm from "layouts/admin/talentAcquisition/ExternalForm";
import SuperAdminPanel from "layouts/super admin/homepage";
import ManageCompany from "layouts/super admin/manageCompany";
import ErrorLogsPage from "layouts/super admin/logsPage";
import SupportTicketsPage from "layouts/super admin/supportTickets";
import LearningAndDevelopment from "layouts/user/Competencies/learningAndDevelopment";
import EmployeeWorkload from "layouts/user/KPIs/myTeam/components/EmployeeWorkload";

const getURoutes = (t, role, isTopManagement) => [
  {
    type: "collapse",
    name: t("uroutes.dashboard"),
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/home",
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    category: t("uroutes.kpis"),
    name: t("uroutes.myTeam"),
    module: "Performance",
    key: "team",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/team",
    component: (
      <ProtectedRoute>
        <TeamView />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    category: t("uroutes.kpis"),
    name: t("uroutes.assess"),
    key: "KPIs/assess",
    module: "Performance",
    icon: <Icon fontSize="small">leaderboard</Icon>,
    route: "/KPIs/assess",
    component: (
      <ProtectedRoute>
        <Assess />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    category: t("uroutes.kpis"),
    // name: t("uroutes.myScorecard"),
    name: role === 1 ? t("uroutes.strategicRoadmap") : t("uroutes.myScorecard"),
    key: "scorecard",
    module: "Performance",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/scorecard",
    component: (
      <ProtectedRoute>
        <MyScorecard />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    name: t("uroutes.chat"),
    key: "chat",
    module: "Performance",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/chat/:chatRoomId",
    component: (
      <ProtectedRoute>
        <ChatPage />
      </ProtectedRoute>
    ),
  },
  {
    type: "hidden",
    name: t("uroutes.othersScorecard"),
    key: "other's scorecard",
    module: "Performance",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/team/scorecard",
    component: (
      <ProtectedRoute>
        <MyScorecard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    category: t("uroutes.competencies"),
    name: t("user.trainings.trainings"),
    module: "Competencies",
    key: "training",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/training",
    component: (
      <ProtectedRoute>
        <TrainingsTab />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    category: t("uroutes.competencies"),
    name: t("uroutes.assess"),
    module: "Competencies",
    key: "competencies/assess",
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/competencies/assess",
    component: (
      <ProtectedRoute>
        <CompetencyToEmpTab />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    category: t("uroutes.competencies"),
    name: t("uroutes.myCompetencies"),
    module: "Competencies",
    key: "mycompetencies",
    icon: <Icon fontSize="small">auto_graph</Icon>,
    route: "/mycompetencies",
    component: (
      <ProtectedRoute>
        <MyCompetencies />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    name: t("uroutes.competencies"),
    key: "other's competencies",
    module: "Competencies",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/team/competencies",
    component: (
      <ProtectedRoute>
        <MyCompetencies />
      </ProtectedRoute>
    ),
  },

  isTopManagement && {
    type: "collapse",
    category: t("uroutes.manpowerPlanning"),
    module: "WLA",
    name: t("uroutes.myTeam"),
    key: "manpower/team",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/manpower/team",
    component: (
      <ProtectedRoute>
        <AnalysisContainerPage />
      </ProtectedRoute>
    ),
  },
  isTopManagement && {
    type: "collapse",
    category: t("uroutes.manpowerPlanning"),
    module: "WLA",
    name: t("uroutes.simulation"),
    key: "manpower/simulation",
    icon: <Icon fontSize="small">science</Icon>,
    route: "/manpower/simulation",
    component: (
      <ProtectedRoute>
        <ScenariosListPage />
      </ProtectedRoute>
    ),
  },

  isTopManagement && {
    type: "hidden",
    category: t("uroutes.manpowerPlanning"),
    module: "WLA",
    name: t("uroutes.simulation"),
    key: "manpower/scenarios",
    icon: <Icon fontSize="small">science</Icon>,
    route: "/manpower/simulation/scenarios",
    component: (
      <ProtectedRoute>
        <ScenarioPageContainer />
      </ProtectedRoute>
    ),
  },

  isTopManagement && {
    type: "hidden",
    category: t("uroutes.manpowerPlanning"),

    name: "Hours Calculator",
    key: "hours-calculator",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/hours-calculator",
    component: (
      <ProtectedRoute>
        <HoursCalculator />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: t("routes.talentAcquisition"),
    module: "Talent Acquisition",
    key: "recruiting",
    icon: <Icon fontSize="small">person_search</Icon>,
    route: "/recruiting",
    component: (
      <ProtectedRoute>
        <TalentAcquisitionPage />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    category: t("routes.talentAcquisition"),

    name: "Requisition Details",
    key: "recruiting/details",
    module: "Talent Acquisition",
    icon: <Icon fontSize="small">person_search</Icon>,
    route: "/recruiting/details",
    component: (
      <ProtectedRoute>
        <RequisitionDetails />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    category: t("uroutes.profile"),
    name: t("uroutes.profile"),
    key: "profile",
    route: "/profile",
    component: (
      <ProtectedRoute>
        <Overview />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: t("uroutes.signOut"),
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-out",
    component: <SignOut />,
  },

  {
    type: "hidden",
    name: t("uroutes.signIn"),
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: (
      <SignInProtectionRoute>
        <SignIn />
      </SignInProtectionRoute>
    ),
  },
  {
    type: "hidden", // This hides it from the Sidebar
    name: "Super Admin Panel",
    key: "super-admin",
    route: "/super-admin",
    component: (
      // Ensure you wrap this in a check so normal HR admins can't access it via URL
      <ProtectedRoute>
        <SuperAdminPanel />
      </ProtectedRoute>
    ),
  },
  {
    type: "hidden", // Hidden from sidebar
    name: "Manage Company",
    key: "manage-company",
    route: "/super-admin/manage",
    component: (
      // Add your ProtectedRoute wrapper here if needed
      <ProtectedRoute>
        <ManageCompany />
      </ProtectedRoute>
    ),
  },
  {
    type: "hidden", // Hidden from sidebar
    name: "Error Logs",
    key: "error-logs",
    route: "/super-admin/logs",
    component: (
      // Add your ProtectedRoute wrapper here if needed
      <ProtectedRoute>
        <ErrorLogsPage />
      </ProtectedRoute>
    ),
  },
  {
    type: "hidden", // Hidden from sidebar
    name: "Support Tickets",
    key: "support-tickets",
    route: "/super-admin/tickets",
    component: (
      // Add your ProtectedRoute wrapper here if needed
      <ProtectedRoute>
        <SupportTicketsPage />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    name: "Job Details",
    module: "Organization",
    key: "jobDetails",
    icon: <Icon fontSize="small">leaderboard</Icon>,
    route: "/job-details",
    component: (
      <ProtectedRoute>
        <JobDetails />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    category: t("uroutes.learningAndDevelopment.title"),
    name: "Learning And Development",
    key: "learning-and-development",
    icon: <Icon fontSize="small">model_training</Icon>,
    route: "/learning-and-development",
    component: (
      <ProtectedRoute>
        <LearningAndDevelopment />
      </ProtectedRoute>
    ),
  },

  {
    type: "hidden",
    category: t("uroutes.manpowerPlanning"),

    name: "Employee Workload",
    key: "employee-workload",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/employee-workload",
    component: (
      <ProtectedRoute>
        <EmployeeWorkload />
      </ProtectedRoute>
    ),
  },
];

export default getURoutes;
